import ExternalContext from "configurator-studio-arkitekter-components/dist/common/components/App/externalContext";

export default ExternalContext;
